var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"eventlist"}},[_c('h3',[_vm._v("Events")]),_vm._v(" "),_c('ul',_vm._l((_vm.events),function(event){return _c('li',{staticClass:"event"},[_c('p',[_vm._v(_vm._s(_vm.renderTime(event.time)))]),_vm._v(" "),_c('h2',[_vm._v(_vm._s(_vm.eventText(event.id, event.param1, event.param2)))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c6c9aa4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Eventlist.vue
// module id = null
// module chunks = 